module.exports = __webpack_public_path__ + "img/sixpackcarrier45.c775475b.jpg";